import * as React from 'react';
import { getDoc, setDoc, doc, query, collection, getDocs, orderBy, where } from "firebase/firestore";
import { database } from '../firebase-config';
import { roundToDollars } from '../utils/MoneyUtils';
import { History } from '../data/History';
import { Timestamp } from "firebase/firestore";
import { getIngredientMapsFromDB } from "./IngredientData";
import { updateAffectedProductsRecipe } from "./ProductData";

const COLLECTION = "recipes";

export class Recipe {
  document_reference = ""
  name = ""
  hours_taken = 0
  makes_qty = 0
  note = ""
  cost_per_item_high = 0
  cost_per_item_low = 0
  total_ingredient_cost = 0
  total_batch_cost_high = 0
  total_batch_cost_low = 0
  low_profit_index = 0
  ingredients = new Array()
  is_deleted = false
  last_update = ""
  history = new Array()
}

export class RecipeMaps {
  recipeMap = new Map()
  recipeMapNoDeleted = new Map()
}

export class Recipies {
  recipeList = new Array()
  options = new Array()
  docMap = new Map()
  refMap = new Map()
}

export class RecipeIngrediant {
  name = ""
  quantity = 0
}

export const getRecipeMapFromDB = async () => {
  let recipeMaps = new RecipeMaps();
  try {
    const docQuery = query(collection(database, COLLECTION));

    const querySnapshot = await getDocs(docQuery);
    querySnapshot.forEach((doc) => {
      recipeMaps.recipeMap.set(doc.id, doc.data());
      if (!doc.data().is_deleted) {
        recipeMaps.recipeMapNoDeleted.set(doc.id, doc.data());
      }

    });
  } catch (e) {
    console.log("Error getting ingredients:", e);
  }
  return recipeMaps;
};

export function makeIngredientMap(ingredients, ingredientMap) {
  let map = new Map();
  if (!ingredients || ingredients.length === 0) {
    return map;
  }
  ingredients.forEach(ingredientRefQuantity => {
    let ingredientParts = ingredientRefQuantity.split(":");
    let ingredientRef = ingredientParts[0];
    let quantity = ingredientParts[1];
    let ingredientDoc = ingredientMap.get(ingredientRef)
    if (ingredientDoc && ingredientDoc !== '') {
      map.set(ingredientRef, {
        "description": ingredientDoc.description,
        "cost": ingredientDoc.cost,
        "per": ingredientDoc.per,
        "quantity": quantity,
        "total_cost": (ingredientDoc.cost * quantity),
      });
    }
  });
  return map;
}

export const getRecipies = async (get_deleted) => {
  let recipies = new Recipies();

  try {
    const docQuery = query(collection(database, COLLECTION), orderBy("name", "asc"));

    const querySnapshot = await getDocs(docQuery);
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      if ((get_deleted)
        || (!get_deleted && !doc.data().is_deleted)) {
        recipies.docMap.set(doc.id, doc.data());
        recipies.refMap.set(doc.id, React.createRef());
        let option = { id: doc.id, value: doc.data().name };
        recipies.options.push(option);
        recipies.recipeList.push(doc);
      }
    });
  } catch (e) {
    console.log("Error getting Recipes:", e);
  }
  return recipies;

}

export const getRecipe = async (documentRef) => {
  try {
    const existingDocRef = doc(database, COLLECTION, documentRef);
    const existingDoc = await getDoc(existingDocRef);
    return existingDoc;
  } catch (e) {
    console.log("getRecipe(): Error getting Recipe ref:" + this.props.docRef);
  }
}

export function getDocData(recipe) {
      let now = Timestamp.now();
  
   let docData = {
      name: recipe.name,
      hours_taken: recipe.hours_taken,
      makes_qty: recipe.makes_qty,
      note: recipe.note,
      total_ingredient_cost: recipe.total_ingredient_cost,
      total_batch_cost_high: recipe.total_batch_cost_high,
      total_batch_cost_low: recipe.total_batch_cost_low,
      cost_per_item_high: recipe.cost_per_item_high,
      cost_per_item_low: recipe.cost_per_item_low,
      low_profit_index: recipe.low_profit_index,
      ingredients: recipe.ingredients,
      is_deleted: recipe.is_deleted,
      last_update: now,
      history: recipe.history,
    };

    return docData;
}

export const recipeNameExists = async (documentRef) => {
  let existingDoc = await getRecipe(documentRef);
  if (existingDoc.data()) {
    return true;
  } else {
    return false;
  }
}

export function documentToRecipe(document) {
  let recipe = new Recipe();
  recipe.document_reference = document.id;
  recipe.name = document.data().name;
  recipe.hours_taken = document.data().hours_taken;
  recipe.makes_qty = document.data().makes_qty;
  recipe.note = document.data().note;
  recipe.cost_per_item_high = document.data().cost_per_item_high;
  recipe.cost_per_item_low = document.data().cost_per_item_low;
  recipe.total_batch_cost_high = document.data().total_batch_cost_high;
  recipe.total_batch_cost_low = document.data().total_batch_cost_low;
  recipe.total_ingredient_cost = document.data().total_ingredient_cost;
  recipe.low_profit_index = document.data().low_profit_index;
  recipe.ingredients = document.data().ingredients;
  recipe.is_deleted = (document.data().is_deleted ? document.data().is_deleted : false);
  recipe.last_update = document.data().last_update;
  recipe.history = document.data().history;

  return recipe;
}

export function getTotalIngredientCosts(ingredients, ingredientMap) {
  let ingredientsTotal = 0.0;
  ingredients.forEach((ingredientRefQuantity) => {
    let ingredientParts = ingredientRefQuantity.split(":");
    let ingredientRef = ingredientParts[0];
    let quantity = ingredientParts[1];
    let ingredientDoc = ingredientMap.get(ingredientRef);
    ingredientsTotal = ingredientsTotal + (ingredientDoc.cost * quantity);
  })
  return ingredientsTotal;
}

export function recalculateCosts(settings, inRecipe, ingredientMap) {

  let tempRecipe = inRecipe;

  /**
   * If the hours taken or makes quantity or ingredients are null or 0, just return.
   */
  if (tempRecipe.hours_taken === ''
    || tempRecipe.hours_taken === 0) {
    return tempRecipe;
  }

  if (tempRecipe.makes_qty === ''
    || tempRecipe.makes_qty === 0) {
    return tempRecipe;
  }

  if (tempRecipe.ingredients === ''
    || tempRecipe.ingredients.length === 0) {
    return tempRecipe;
  }

  let totoalIngredientsCost = getTotalIngredientCosts(tempRecipe.ingredients, ingredientMap);
  let totalTimeAndMaterialCost = totoalIngredientsCost + (settings.hourly_labor_rate * tempRecipe.hours_taken);
  let totatBatchCostHigh = totalTimeAndMaterialCost * settings.profit_index;
  let totatBatchCostLow = totalTimeAndMaterialCost * tempRecipe.low_profit_index;
  let costPerItemHigh = totatBatchCostHigh / tempRecipe.makes_qty;
  let costPerItemLow = totatBatchCostLow / tempRecipe.makes_qty;

  tempRecipe.total_ingredient_cost = totoalIngredientsCost;
  tempRecipe.total_batch_cost_high = totatBatchCostHigh;
  tempRecipe.total_batch_cost_low = totatBatchCostLow;
  tempRecipe.cost_per_item_high = costPerItemHigh;
  tempRecipe.cost_per_item_low = costPerItemLow;

  return tempRecipe;
}

export const saveRecipe = async (docRef, recipeData) => {
  try {
    await setDoc(doc(database, COLLECTION, docRef), recipeData, { merge: true });
    /**
     * Update all the Products with this recipe.
     */
    updateAffectedProductsRecipe(docRef);
  } catch (e) {
    console.log("Error saving Recipe:", e);
  }
}

export async function updateAffectedRecipies(settings, ingredientRef) {
  /**
   * Get the list of impacted recipies.  Since the ingredient cost can change, the cost
   * of the recipe will change.
   */
  let affectedRecipes = await getAffectedRecipes(ingredientRef);
  /**
   * For each affected recipe:
   * - recalculate the costs
   * - save the recipe
   * - update the history
   */
  affectedRecipes.forEach(async (affectedRecipe) => {
    let recipeRef = affectedRecipe.id;
    let recipeData = affectedRecipe.data();
    let ingredientMap = await getIngredientMapsFromDB();
    let updatedRecipe = recalculateCosts(settings, recipeData, ingredientMap);
    let now = Timestamp.now();
    await recordHistory(updatedRecipe.history, now, updatedRecipe, recipeRef);
    saveRecipe(recipeRef, updatedRecipe);
  });
}

async function getAffectedRecipes(ingredientRef) {
  let affectedRecipes = new Array();
  try {

    const docQuery = query(collection(database, COLLECTION));

    const querySnapshot = await getDocs(docQuery);
    querySnapshot.forEach((recipe) => {
      let ingredients = new Array();
      ingredients = recipe.data().ingredients;
      ingredients.forEach((ingredient) => {
        if (ingredient.startsWith(ingredientRef)) {
          affectedRecipes.push(recipe);
        }
      });
    });

    return affectedRecipes;
  } catch (e) {
    console.log("Error determining affected recipes:", e);
  }
}
/**
* ------------ Start History ----------------
*/
export const getHistoryRecord = async (history_key) => {
  const existingHistoryRef = doc(database, "history", history_key);
  const existingHistory = await getDoc(existingHistoryRef);
  const historyRecord = new History();
  historyRecord.key = history_key;
  historyRecord.updateDate = existingHistory.data().last_updated;
  historyRecord.field = existingHistory.data().field;
  historyRecord.oldValue = existingHistory.data().oldValue;
  historyRecord.newValue = existingHistory.data().newValue;
  return historyRecord;
}

export const loadHistoryMap = async (historyList) => {
  let map = new Map();
  let reversedHistory = historyList.reverse();
  for (let ii = 0; ii < 11 && ii < historyList.length; ii++) {
    try {
      let historyRecord = await getHistoryRecord(reversedHistory[ii]);
      map.set(reversedHistory[ii], historyRecord);
    } catch (e) {
      console.log("Error getting history ref:" + reversedHistory[ii]);
    }
  }
  return map;
}

function addHistory(newHistoryList, now, recipeName, field, oldValue, newValue) {
  let docData = {
    last_updated: now,
    field: field,
    oldValue: oldValue,
    newValue: newValue,
  };

  let documentName = 'recipe_' + recipeName + '_' + field + "_" + now;

  try {
    setDoc(doc(database, "history", documentName), docData);
  } catch (e) {
    console.log("Error saving History:", e);
    return;
  }

  newHistoryList.push(documentName);
}

function ingrediantsEqual(newIngredients, oldIngredients) {
  if (newIngredients.length !== oldIngredients.length) return false;
  for (let ii = 0; ii < newIngredients.length; ii++) {
    if (newIngredients[ii] !== oldIngredients[ii]) return false;
  }
  return true;
}

export const recordHistory = async (newHistoryList, now, newRecipe, oldRecipeRef) => {
  let existingDoc = "";
  try {
    let oldDocRef = doc(database, COLLECTION, oldRecipeRef);
    existingDoc = await getDoc(oldDocRef);
  } catch (e) {
    console.log("Error getting existing Recipe for History:", e);
  }
  let oldRecipe = existingDoc.data();

  try {
    if (newRecipe.name !== oldRecipe.name) {
      addHistory(newHistoryList, now, oldRecipeRef, "name", oldRecipe.name, newRecipe.name);
    }
    if (newRecipe.cost_per_item !== oldRecipe.cost_per_item) {
      addHistory(newHistoryList, now, oldRecipeRef, "cost_per_item", roundToDollars(oldRecipe.cost_per_item), roundToDollars(newRecipe.cost_per_item));
    }
    if (newRecipe.hours_taken !== oldRecipe.hours_taken) {
      addHistory(newHistoryList, now, oldRecipeRef, "hours_taken", oldRecipe.hours_taken, newRecipe.hours_taken);
    }
    if (newRecipe.makes_qty !== oldRecipe.makes_qty) {
      addHistory(newHistoryList, now, oldRecipeRef, "makes_qty", oldRecipe.makes_qty, newRecipe.makes_qty);
    }
    if (oldRecipe.note && newRecipe.note !== oldRecipe.note) {
      addHistory(newHistoryList, now, oldRecipeRef, "note", oldRecipe.note, newRecipe.note);
    }
    if (newRecipe.cost_per_item_high !== oldRecipe.cost_per_item_high) {
      addHistory(newHistoryList, now, oldRecipeRef, "cost_per_item_high", roundToDollars(oldRecipe.cost_per_item_high), roundToDollars(newRecipe.cost_per_item_high));
    }
    if (newRecipe.cost_per_item_low !== oldRecipe.cost_per_item_low) {
      addHistory(newHistoryList, now, oldRecipeRef, "cost_per_item_low", roundToDollars(oldRecipe.cost_per_item_low), roundToDollars(newRecipe.cost_per_item_low));
    }
    if (newRecipe.total_batch_cost_high !== oldRecipe.total_batch_cost_high) {
      addHistory(newHistoryList, now, oldRecipeRef, "total_batch_cost_high", roundToDollars(oldRecipe.total_batch_cost_high), roundToDollars(newRecipe.total_batch_cost_high));
    }
    if (newRecipe.total_batch_cost_low !== oldRecipe.total_batch_cost_low) {
      addHistory(newHistoryList, now, oldRecipeRef, "total_batch_cost_low", roundToDollars(oldRecipe.total_batch_cost_low), roundToDollars(newRecipe.total_batch_cost_low));
    }
    if (newRecipe.total_ingredient_cost !== oldRecipe.total_ingredient_cost) {
      addHistory(newHistoryList, now, oldRecipeRef, "total_ingredient_cost", roundToDollars(oldRecipe.total_ingredient_cost), roundToDollars(newRecipe.total_ingredient_cost));
    }
    if (newRecipe.total_high_profit !== oldRecipe.total_high_profit) {
      addHistory(newHistoryList, now, oldRecipeRef, "total_high_profit", roundToDollars(oldRecipe.total_high_profit), roundToDollars(newRecipe.total_high_profit));
    }
    if (newRecipe.total_low_profit !== oldRecipe.total_low_profit) {
      addHistory(newHistoryList, now, oldRecipeRef, "total_low_profit", roundToDollars(oldRecipe.total_low_profit), roundToDollars(newRecipe.total_low_profit));
    }
    if (newRecipe.is_deleted !== oldRecipe.is_deleted) {
      let oldRecipeDeleted = "";
      if (!oldRecipe.is_deleted) {
        oldRecipeDeleted = "undefined"
      } else if (oldRecipe.is_deleted === true) {
        oldRecipeDeleted = "True"
      } else if (oldRecipe.is_deleted === true) {
        oldRecipeDeleted = "True"
      }

      let newRecipeDeleted = "";
      if (!newRecipe.is_deleted) {
        newRecipeDeleted = "undefined"
      } else if (newRecipe.is_deleted === true) {
        newRecipeDeleted = "True"
      } else if (newRecipe.is_deleted === true) {
        newRecipeDeleted = "True"
      }
      addHistory(newHistoryList, now, oldRecipeRef, "is_deleted", oldRecipeDeleted, newRecipeDeleted);
    }
    if (!ingrediantsEqual(newRecipe.ingredients, oldRecipe.ingredients)) {
      addHistory(newHistoryList, now, oldRecipeRef, "ingredients", oldRecipe.ingredients, newRecipe.ingredients);
    }
  } catch (e) {
    console.log("Error adding history for:" + existingDoc.id);
  }
}
/**
 * ------------ End History ----------------
 */